module.exports = {
      id: "appstore-usage",
      viewBox: "0 0 120 40",
      url: __webpack_public_path__ + "svg-sprite-f0666e191f9085fc3de3ed484b6b7fae.svg#appstore",
      toString: function () {
        return this.url;
      }
    }